module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_1-007860836eb1935ee8ae9aa0b6717dff.svg";